export const container = () => ({
    gridColumnStart: 'auto',
    gridColumnEnd: 'span 12',
    position: 'relative',

    tabletLarge: {
        gridColumnStart: 'auto',
        gridColumnEnd: 'span 4',
        paddingLeft: '1.5rem',
        paddingRight: '1.5rem',
    },
});

export const extendTitle = () => ({
    tabletLarge: {
        fontSize: '2rem',
    },
});

export const extendText = () => ({
    fontSize: '1.125rem',
    marginBottom: 0,
});

export const divider = ({ theme: { colors } }) => ({
    backgroundColor: colors.lightGrey,

    width: '100%',
    height: '0.0625rem',

    marginTop: '1.75rem',

    tabletLarge: {
        marginTop: 'unset',

        position: 'absolute',
        top: 0,
        right: '-0.6rem',

        width: '0.0625rem',
        height: '100%',
    },
});
